import React from "react";
import { Card, Col, Row } from "react-bootstrap";

import classNames from "classnames";

import useTeamGames from "@Leagues/hooks/useTeamGames";
import formatGameDate from "@Leagues/lib/formatGameDate";
import getOpponentInfo from "@Leagues/lib/getOpponentInfo";
import { GameProps } from "@Leagues/types/leagues";

const Games = (props: GameProps): React.JSX.Element => {
    let { schedule, teamId } = props;
    const currentDate = new Date();
    const { recent, next } = useTeamGames(teamId, currentDate, schedule);

    const { prefix: recentPrefix, opponent: recentOpponent } = recent.game
        ? getOpponentInfo(recent.game, teamId)
        : { prefix: "", opponent: "" };

    const { prefix: nextPrefix, opponent: nextOpponent } = next.game
        ? getOpponentInfo(next.game, teamId)
        : { prefix: "", opponent: "" };

    return (
        <Row className="team-games">
            <Col className="col-lg-6 col-12 mb-4">
                <h2 className="section-title">Most Recent Game</h2>
                <Card className="game-card">
                    {recent.game ? (
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <div className="game-opponent">
                                    {recentPrefix} {recentOpponent}
                                </div>
                                <div className="game-details">
                                    {formatGameDate(recent.game.date)}
                                    <br />
                                    {recent.game.fieldName}
                                </div>
                            </div>
                            <div className="text-end">
                                <div
                                    className={classNames("game-score", {
                                        win: recent.result === "W",
                                        loss: recent.result === "L",
                                    })}
                                >
                                    {recent.score || (
                                        <span style={{ fontSize: "1rem" }}>
                                            No score reported yet
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-muted">No recent games found</div>
                    )}
                </Card>
            </Col>

            <Col className="col-lg-6 col-12 mb-4">
                <h2 className="section-title">Next Game</h2>
                <Card className="game-card">
                    {next.game ? (
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <div className="game-opponent">
                                    {nextPrefix} {nextOpponent}
                                </div>
                                <div className="game-details">
                                    {formatGameDate(next.game.date)}
                                    <br />
                                    {next.game.fieldName}
                                    {next.game.diamond
                                        ? ` - ${next.game.diamond}`
                                        : ""}
                                    {next.game.note ? (
                                        <>
                                            <br />
                                            Field Note: {next.game.note}
                                        </>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-muted">
                            No upcoming games scheduled
                        </div>
                    )}
                </Card>
            </Col>
        </Row>
    );
};

export default Games;
